import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-picpay',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>PicPay icon</title><path d="M16.463 1.587v7.537H24V1.587zm1.256 1.256h5.025v5.025h-5.025zm1.256 1.256v2.513h2.513V4.099zM3.77 5.355V8.53h3.376c2.142 0 3.358 1.04 3.358 2.939 0 1.947-1.216 3.011-3.358 3.011H3.769V8.53H0v13.884h3.769v-4.76h3.57c4.333 0 6.815-2.352 6.815-6.32 0-3.771-2.482-5.978-6.814-5.978Z"/></svg>`,
    styles: []
})
export class SimpleIconsPicpayComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#21C25E';
    @Input() className: string = 'simple-icons-picpay'
    constructor() {}
    ngOnInit(): void {}
}
